import classNames from 'classnames';
import { createElement, useEffect, useState } from 'react';
import './index.scss';
const ColorfulBadge = props => {
    const { content, color, children, position, ...otherProps } = props;
    const [positionStyle, setPositionStyle] = useState();
    const classPrefix = `au-badge`;
    const badgeCls = classNames(`${classPrefix}-box`, !!children && `${classPrefix}-fixed`);
    useEffect(() => {
        const style = getPlacement(position);
        setPositionStyle(style);
    }, [position]);
    const getPlacement = (position) => {
        switch (position) {
            case "TL":
                return {
                    top: 0,
                    left: 0,
                    transform: 'translate(-50%,-50%)',
                };
            case "TR":
                return {
                    top: 0,
                    right: 0,
                    transform: 'translate(50%, -50%)',
                };
            case "BL":
                return {
                    bottom: 0,
                    left: 0,
                    transform: 'translate(-50%, 50%)',
                };
            case "BR":
                return {
                    bottom: 0,
                    right: 0,
                    transform: 'translate(50%, 50%)',
                };
            default:
                return {
                    top: 0,
                    right: 0,
                    transform: 'translate(50%, -50%)',
                };
        }
    };
    return (createElement("div", { className: classPrefix, ...otherProps },
        children,
        createElement("div", { className: badgeCls, style: positionStyle }, content ? (createElement("div", { className: `${classPrefix}-content`, style: { background: color } }, content)) : (createElement("div", { className: `${classPrefix}-dot`, style: { background: color } })))));
};
ColorfulBadge.displayName = 'ColorfulBadge';
export default ColorfulBadge;
